export default __webpack_public_path__ + "static/media/portfolio.f8c526d5.JPG";